export { default } from './OptimizedImage';
